var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4991 2.25L8.9891 6.74C9.02419 6.7736 9.05211 6.81396 9.07119 6.85865C9.09026 6.90333 9.1001 6.95141 9.1001 7C9.1001 7.04859 9.09026 7.09667 9.07119 7.14135C9.05211 7.18604 9.02419 7.2264 8.9891 7.26L4.4991 11.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8999 11.75L13.3899 7.26C13.425 7.2264 13.4529 7.18604 13.472 7.14135C13.4911 7.09667 13.5009 7.04859 13.5009 7C13.5009 6.95141 13.4911 6.90333 13.472 6.85865C13.4529 6.81396 13.425 6.7736 13.3899 6.74L8.8999 2.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightright);
export default __webpack_public_path__ + "static/media/rightright.8ff072b4d9a693d79233241186a6b09d.svg";
export { ForwardRef as ReactComponent };